import AbstractComponent from "./abstract-component";

class Logo extends AbstractComponent {
  render() {
    const {data: image, options: {margin, alignment, width}} = this;

    return {
      image,
      width,
      alignment,
      margin
    }
  }

  getDefaultOptions() {
    return {
      width: 196,
      alignment: 'center',
      margin: [0, 0, 0, 0]
    }
  }

  getDefaultData() {
    return 'logo';
  }
}

export default Logo.asFunction();
